var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: {
        form: _vm.form,
        rules: _vm.rules,
        "label-width": "120px",
        width: "1000px",
      },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("SettingBaseDataConfig.addAndEdit.msg")) + " "),
      ]),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataConfig.addAndEdit.channel"),
                prop: "channelCode",
              },
            },
            [
              _c("BjSelectLov", {
                attrs: { "lov-code": "SCHL.CHANNEL_TYPE" },
                model: {
                  value: _vm.form.channelCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "channelCode", $$v)
                  },
                  expression: "form.channelCode",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataConfig.addAndEdit.logo"),
                prop: "systemFlagCode",
              },
            },
            [
              _c("BjSelectLov", {
                attrs: { "lov-code": "THIRD.CONFIG_FLAG" },
                model: {
                  value: _vm.form.systemFlagCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "systemFlagCode", $$v)
                  },
                  expression: "form.systemFlagCode",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "SettingBaseDataConfig.addAndEdit.applicationName"
                ),
                prop: "appName",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.appName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "appName", $$v)
                  },
                  expression: "form.appName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "SettingBaseDataConfig.addAndEdit.applicationType"
                ),
                prop: "appType",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.appType,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "appType", $$v)
                  },
                  expression: "form.appType",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "app_key", prop: "appKey" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: 100,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.appKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "appKey", $$v)
                  },
                  expression: "form.appKey",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "app_secret", prop: "appSecret" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: 100,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.appSecret,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "appSecret", $$v)
                  },
                  expression: "form.appSecret",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataConfig.addAndEdit.authorize"),
                prop: "authUrl",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.REMARK,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.authUrl,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "authUrl", $$v)
                  },
                  expression: "form.authUrl",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataConfig.addAndEdit.otherAddress"),
                prop: "otherUrl",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.REMARK,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.otherUrl,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "otherUrl", $$v)
                  },
                  expression: "form.otherUrl",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataConfig.addAndEdit.api"),
                prop: "apiServiceUrl",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.REMARK,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.apiServiceUrl,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "apiServiceUrl", $$v)
                  },
                  expression: "form.apiServiceUrl",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "SettingBaseDataConfig.addAndEdit.callbackAddress"
                ),
                prop: "callBackUrl",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.REMARK,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.callBackUrl,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "callBackUrl", $$v)
                  },
                  expression: "form.callBackUrl",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataConfig.addAndEdit.certificate"),
                prop: "certificateFlow",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.certificateFlow,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "certificateFlow", $$v)
                  },
                  expression: "form.certificateFlow",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "SettingBaseDataConfig.addAndEdit.authorizeAccount"
                ),
                prop: "authAccount",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.authAccount,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "authAccount", $$v)
                  },
                  expression: "form.authAccount",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataConfig.addAndEdit.openPlatform"),
                prop: "platformAddress",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.REMARK,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.platformAddress,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "platformAddress", $$v)
                  },
                  expression: "form.platformAddress",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataConfig.addAndEdit.account"),
                prop: "account",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.account,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "account", $$v)
                  },
                  expression: "form.account",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("SettingBaseDataConfig.addAndEdit.remark"),
                prop: "remark",
              },
            },
            [
              _c("BjTextarea", {
                attrs: {
                  placeholder: _vm.$t(
                    "SettingBaseDataConfig.addAndEdit.remark"
                  ),
                },
                model: {
                  value: _vm.form.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }